app
    .controller('OfferConfirmationCtrl', function ($http, $window) {

        this.cancel = () => {
            this.dismiss();
        };

        this.openProgram = () => {
            $window.location.href = '/programs/'+ this.resolve.offerDetails.programOffer.program.id + '-' +
            this.resolve.offerDetails.programOffer.program.slug;
        };

        this.$onInit = () => {
        };
    })
    .component('offerConfirmation', {
        template: `
        <div class="px-4 py-2" style="width: 100%; min-width: 32vw;">
            <div class="modal-header header p-1 mb-2" style="border-bottom: 1px solid #1D1D1B;">
                <h1 style="font-size: 24px; font-family: 'goboldregular', Impact, sans-serif;margin: 10px auto; text-align: center;">
                    <chat-icon type="program" width="20" height="28"></chat-icon> <span class="ml-2">PROGRAM PROPOSITION</span>
                </h1>
                <button class="btn btn-close" ng-click="$ctrl.cancel()">
                    <chat-icon type="cross" width="15" />
                </button>
            </div>
            <div class="body" style="max-height: 400px;">
                <div class="row justify-content-center pb-2 mx-0" style="border-bottom: 1px solid #1D1D1B;">
                    <div class="col-4 text-right">
                        <img style="width:40px;" 
                            ng-src="{{ $ctrl.resolve.offerDetails.coachUser.picture ? $ctrl.resolve.offerDetails.coachUser.picture : '/upload/' + $ctrl.resolve.offerDetails.coachUser.defaultPicture }}"/>
                    </div>
                    <div class="col-5 text-left" style="font-size: 16px;vertical-align: middle;line-height: 42px;font-weight: bold;">
                        {{ $ctrl.resolve.offerDetails.coachUser.displayName }}
                    </div>
                </div>
                <div class="row justify-content-center pb-2 mx-0 mt-3" style="border-bottom: 1px solid #1D1D1B;"
                    ng-if="$ctrl.resolve.offerDetails.programOffer.program.photoPath">
                    <div class="col-4 col-sm-4 col-lg-3 pt-0 pb-2 pl-1 pr-1">
                        <div class="sg-item-tile sg-program-tile" style="color:{{$ctrl.resolve.offerDetails.programOffer.program.textColor}};background-color:{{$ctrl.resolve.offerDetails.programOffer.program.backgroundColor}};">
                            <div class="sg-item-tile-inner">
                                <div class="w-100 h-100 bg-no-repeat bg-pos-cc bg-cover" style="background-image:url(&quot;{{ $ctrl.resolve.offerDetails.programOffer.program.photoPath }}&quot;)">
                                    <span class="sr-only">{{ $ctrl.resolve.offerDetails.programOffer.program.objectiveDescription }}, {{ $ctrl.resolve.offerDetails.programOffer.program.description }}, {{ 'gender.'+$ctrl.resolve.offerDetails.programOffer.program.gender| translate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4 text-left" style="font-size: 20px;vertical-align: middle;line-height: 42px;font-weight: bold;">
                        {{ $ctrl.resolve.offerDetails.programOffer.offerDetails.program.displayName }}
                    </div>
                </div>
                <div class="row justify-content-center pb-2 mx-0 mt-3" style="border-bottom: 1px solid #1D1D1B;"
                    ng-if="!$ctrl.resolve.offerDetails.programOffer.program.photoPath">
                    <div class="col-4 col-sm-4 col-lg-3 pt-0 pb-2 pl-1 pr-1 text-center">
                        <div class="sg-item-tile sg-program-tile" style="color:{{$ctrl.resolve.offerDetails.programOffer.program.textColor}};background-color:{{$ctrl.resolve.offerDetails.programOffer.program.backgroundColor}};">
                            <div class="sg-item-tile-inner">
                                <div class="sg-item-tile-scalable">
                                    <ul ng-if="!$ctrl.resolve.offerDetails.programOffer.program.photoPath" class="w-100 h-100 d-flex flex-column flex-nowrap list-unstyled text-bold text-uppercase p-3">
                                        <li>-&nbsp;{{ 'gender.'+$ctrl.resolve.offerDetails.programOffer.program.gender| translate }}&nbsp;-</li>
                                        <li class="text-size-xl mt-auto mb-auto">{{ $ctrl.resolve.offerDetails.programOffer.program.description }}</li>
                                        <li>{{ $ctrl.resolve.offerDetails.programOffer.program.objectiveDescription }}</li>
                                    </ul>
                                </div>    
                            </div>
                        </div>
                    </div>
                </div>
                <div ng-if="$ctrl.resolve.targetAction == 'decline'">
                    <div class="font-go-bold mt-4 text-center" style="font-size: 18px;">
                        <p>{{ 'modal.sendOffer.declined' | translate }}</p>
                    </div>
                </div>
                <div ng-if="$ctrl.resolve.targetAction == 'accept'">
                    <div class="font-go-bold mt-4 text-center" style="font-size: 18px;">
                        <p>{{ 'modal.sendOffer.accepted' | translate }}</p>
                    </div>
                </div>
            </div>
            <div class="footer text-center mb-4">
                <button class="btn btn-green font-go-bold btn-200 mb-2" ng-click="$ctrl.openProgram()" ng-if="$ctrl.resolve.targetAction == 'accept'">
                    {{ 'modal.sendOffer.seeTheProgram' | translate }}
                </button>
                <br>
                <button class="btn btn-reject font-go-bold btn-200" ng-click="$ctrl.cancel()">
                    {{ 'modal.sendOffer.backToprofile' | translate }}
                </button>
            </div>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'OfferConfirmationCtrl'
    });
